<script lang="ts" setup>
  import { StoreLayout } from '@storefront/components';
  import { computed } from 'vue';
  import { useTranslator } from '@othercommerce/foundation';

  defineOptions({
    layout: StoreLayout,
  });

  interface Props {
    title?: string | null;
    description?: string | null;
  }

  const props = defineProps<Props>();
  const translator = useTranslator();

  const title = computed(() => {
    return props.title || translator.trans('SHOP.ERROR.HEADER.404');
  });

  const description = computed(() => {
    return props.description || translator.trans('SHOP.ERROR.MESSAGE.404');
  });
</script>
<template>
  <main class="container not-found">
    <SfSection :title class="not-found__section ">
      <div class="not-found__description" v-html="description" />
      <SfButton :href="$route('web.homepage.index')" class="not-found__redirect" primary>
        <template #before>
          <SfIconChevronLeft aria-hidden="true" />
        </template>
        {{ $t('SHOP.ACTION.HOMEPAGE') }}
      </SfButton>
    </SfSection>
  </main>

  <RouterView />
</template>
<style lang="scss" scoped>
  @use "@storefront/styles/mixins/media";

  .not-found {
    margin-top: 3rem;
    --section-content-gap: 2.5rem;

    &__section {
      align-items: center;

      :deep(.section__header) {
        flex-direction: column;
      }
    }

    &__description {
      max-width: 600px;
      text-align: center;
    }

    &__redirect {
      align-self: center;
    }

    @include media.query(lg) {
      margin-top: 2rem;
      --section-padding: 1rem 0.625rem;
      --section-content-gap: 1.5rem;
    }
  }
</style>
